export default __webpack_public_path__ + "static/media/logo.50a5a058.png";